import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "row col-md-7" }
const _hoisted_3 = { class: "el-input-group" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "row col-md-7" }
const _hoisted_7 = { class: "el-input-group" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "row col-md-7" }
const _hoisted_11 = { class: "el-input-group" }
const _hoisted_12 = { class: "row col-md-7" }
const _hoisted_13 = { class: "el-input-group" }
const _hoisted_14 = { class: "row col-md-7" }
const _hoisted_15 = { class: "el-input-group" }
const _hoisted_16 = { class: "row col-md-7" }
const _hoisted_17 = { class: "el-input-group" }
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = { class: "input-group" }
const _hoisted_20 = { class: "col-md-7" }
const _hoisted_21 = { class: "el-input-group" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "page-content-info d-flex align-items-center justify-content-end" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { key: 1 }
const _hoisted_31 = ["onSubmit"]
const _hoisted_32 = { class: "row col-md-12" }
const _hoisted_33 = { class: "el-input-group" }
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "row col-md-12" }
const _hoisted_37 = { class: "el-input-group" }
const _hoisted_38 = { class: "input-group" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = { class: "row col-md-12" }
const _hoisted_41 = { class: "el-input-group" }
const _hoisted_42 = { class: "input-group" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "row col-md-12" }
const _hoisted_45 = { class: "row col-md-12" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = { class: "md-3" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "md-3" }
const _hoisted_50 = ["value"]
const _hoisted_51 = {
  key: 0,
  class: "md-3"
}
const _hoisted_52 = ["value"]
const _hoisted_53 = {
  key: 1,
  class: "md-3"
}
const _hoisted_54 = ["value"]
const _hoisted_55 = {
  key: 2,
  class: "md-3"
}
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "md-3" }
const _hoisted_58 = { class: "md-3" }
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["disabled"]
const _hoisted_61 = {
  key: 0,
  class: "modal"
}
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = ["disable"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_b_th = _resolveComponent("b-th")!
  const _component_b_tr = _resolveComponent("b-tr")!
  const _component_b_thead = _resolveComponent("b-thead")!
  const _component_b_td = _resolveComponent("b-td")!
  const _component_b_tbody = _resolveComponent("b-tbody")!
  const _component_b_table_simple = _resolveComponent("b-table-simple")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[46] || (_cache[46] = _createElementVNode("h2", null, "Фактическая оплата", -1)),
    _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[19] || (_cache[19] = _createElementVNode("label", {
            for: "accountingMonth",
            class: "form-label col-md-3"
          }, "Расчетный месяц", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "1",
                max: "12",
                step: "1",
                class: "form-control",
                id: "accountingMonth",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParam.accountingMonth) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParam.accountingMonth]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[20] || (_cache[20] = _createElementVNode("label", {
            for: "accountingYear",
            class: "form-label col-md-3"
          }, "Расчетный год", -1)),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                min: "2024",
                step: "1",
                class: "form-control",
                id: "accountingYear",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParam.accountingYear) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchParam.accountingYear]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _cache[21] || (_cache[21] = _createElementVNode("label", {
            for: "binList",
            class: "form-label col-md-3"
          }, "Список бинов:", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "binList",
            cols: "15",
            rows: "5",
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParam.binList) = $event)),
            required: "",
            placeholder: "1234567, 1234567, ...\nили\n1234567\n1234567\n..."
          }, null, 512), [
            [_vModelText, _ctx.searchParam.binList]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[22] || (_cache[22] = _createElementVNode("label", {
            for: "binList",
            class: "form-label col-md-3"
          }, "Список LMS ID:", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "binList",
            cols: "15",
            rows: "5",
            class: "form-control",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParam.lmsIdList) = $event)),
            required: "",
            placeholder: "1-1-1, 1-1-2, ...\nили\n1-1-1\n1-1-2\n..."
          }, null, 512), [
            [_vModelText, _ctx.searchParam.lmsIdList]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[23] || (_cache[23] = _createElementVNode("label", {
            for: "actNumberList",
            class: "form-label col-md-3"
          }, "Список Акт номеров:", -1)),
          _withDirectives(_createElementVNode("textarea", {
            id: "actNumberList",
            cols: "15",
            rows: "5",
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchParam.actNumberList) = $event)),
            required: "",
            placeholder: "250022/00/625, 250022/00/635, ...\nили\n250022/00/625\n250022/00/635\n..."
          }, null, 512), [
            [_vModelText, _ctx.searchParam.actNumberList]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[24] || (_cache[24] = _createElementVNode("label", {
            for: "katoCode",
            class: "form-label col-md-3"
          }, "Населенный пункт", -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_multiselect, {
                modelValue: _ctx.kato,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.kato) = $event)),
                options: _ctx.katoList,
                searchable: true,
                closeOnSelect: true,
                "track-by": "code",
                "custom-label": _ctx.formattedKatoLabel,
                placeholder: "Выберите Като",
                multiple: false,
                "clear-on-select": true
              }, null, 8, ["modelValue", "options", "custom-label"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchKindergartenFactPayment(true))),
            disabled: _ctx.fullPaidAmountForm.isLoading
          }, _toDisplayString(_ctx.fullPaidAmountForm.isLoading ? 'Загрузка...' : 'Поиск'), 9, _hoisted_22),
          _createElementVNode("button", {
            class: "btn btn-warning",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearSearchParam())),
            disabled: _ctx.fullPaidAmountForm.isLoading
          }, "Сбросить фильтр", 8, _hoisted_23),
          (_ctx.pageResponse?.totalElements && _ctx.pageResponse?.totalElements > 0)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-info",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.showFullPaidModel && _ctx.showFullPaidModel(...args))),
                disabled: _ctx.fullPaidAmountForm.isLoading
              }, "Полная выплата по выбранным ДО", 8, _hoisted_24))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          disabled: (_ctx.items?.length === 0) && _ctx.fullPaidAmountForm.isLoading,
          class: "btn btn-info align-items-center justify-content-end",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadFactPaymentReport()))
        }, "Выгрузить результат по фильтру ", 8, _hoisted_26),
        _createElementVNode("button", {
          class: "btn btn-success align-items-center justify-content-end",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showUploadModal = true))
        }, "Загрузить номера выплат")
      ])
    ]),
    _createVNode(_component_b_pagination, {
      modelValue: _ctx.currentPage,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentPage) = $event)),
      "total-rows": _ctx.pageResponse?.totalElements,
      "per-page": _ctx.searchParam.perPage
    }, null, 8, ["modelValue", "total-rows", "per-page"]),
    _createVNode(_component_b_table_simple, { bordered: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_b_thead, { "head-variant": "light" }, {
          default: _withCtx(() => [
            _createVNode(_component_b_tr, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("БИН")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[26] || (_cache[26] = [
                    _createTextVNode("LMS ID")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                    _createTextVNode("Населенный пункт")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[28] || (_cache[28] = [
                    _createTextVNode("Расчетный месяц и год")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                    _createTextVNode("Общая сумма для выплаты")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("Выплачено")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode("Осталось выплатить")
                  ])),
                  _: 1
                }),
                _createVNode(_component_b_th, null, {
                  default: _withCtx(() => _cache[32] || (_cache[32] = [
                    _createTextVNode("#")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_tbody, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createBlock(_component_b_tr, { key: index }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_td, {
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.bin), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_b_td, {
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.lmsId), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_b_td, {
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.lmsSystem.kato.nameRu), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_b_td, {
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.accountingMonth) + "." + _toDisplayString(item.accountingYear), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_b_td, {
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.totalSum), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_b_td, {
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.totalPaidAmount) + " ", 1),
                      (item.totalPaidAmount == item.totalSum)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "✅"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_b_td, {
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.totalReminderAmount), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _createVNode(_component_b_td, {
                    style: {"width":"15%"},
                    class: _normalizeClass(["default", [_ctx.paidAmountForm[item.id].valueId !== null && item.id === _ctx.paidAmountForm[item.id].valueId ? 'success' : '']])
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.kindergartenPaidAmounts, (paidAmountData, index2) => {
                        return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", null, "Дата: " + _toDisplayString(_ctx.formatDate(paidAmountData.paidDate)), 1),
                            _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", null, "Сумма: " + _toDisplayString(paidAmountData.paidAmount) + " тг.", 1),
                            _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("span", null, "Номер: " + _toDisplayString(paidAmountData.paymentNumber), 1),
                            _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "----------------", -1)),
                            _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1))
                          ])
                        ]))
                      }), 128)),
                      (item.totalReminderAmount && item.totalReminderAmount > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            (!_ctx.paidAmountForm[item.id].showForm)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-info",
                                  onClick: ($event: any) => (_ctx.showPaidForm(item.id))
                                }, "Добавить выплату", 8, _hoisted_29))
                              : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("form", {
                                      class: "row",
                                      onSubmit: _withModifiers(($event: any) => (_ctx.handleSubmit(_ctx.paidAmountForm[item.id].data)), ["prevent"])
                                    }, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                          _createElementVNode("div", _hoisted_34, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "date",
                                              class: "form-control",
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.paidAmountForm[item.id].data.paidDate) = $event),
                                              required: ""
                                            }, null, 8, _hoisted_35), [
                                              [_vModelText, _ctx.paidAmountForm[item.id].data.paidDate]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                          _createElementVNode("div", _hoisted_38, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "number",
                                              step: "0.01",
                                              min: "0.01",
                                              class: "form-control",
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.paidAmountForm[item.id].data.paidAmount) = $event),
                                              required: ""
                                            }, null, 8, _hoisted_39), [
                                              [_vModelText, _ctx.paidAmountForm[item.id].data.paidAmount]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("div", _hoisted_42, [
                                            _withDirectives(_createElementVNode("input", {
                                              type: "text",
                                              class: "form-control",
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.paidAmountForm[item.id].data.paymentNumber) = $event),
                                              placeholder: "Номер выплаты"
                                            }, null, 8, _hoisted_43), [
                                              [_vModelText, _ctx.paidAmountForm[item.id].data.paymentNumber]
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("button", {
                                          type: "submit",
                                          class: _normalizeClass(["btn btn-success", {disabled: _ctx.paidAmountForm[item.id].loading}])
                                        }, "Сохранить", 2)
                                      ]),
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: _normalizeClass(["btn btn-warning", {disabled: _ctx.paidAmountForm[item.id].loading}]),
                                          onClick: ($event: any) => (_ctx.closePaidForm(item.id))
                                        }, "Отмена", 10, _hoisted_46)
                                      ])
                                    ], 40, _hoisted_31)
                                  ])
                                ]))
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.fullPaidAmountForm.isShowModel,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fullPaidAmountForm.isShowModel) = $event)),
      title: "Полная выплата по выбранным ДО",
      "hide-footer": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitSetFullPaidAmount && _ctx.submitSetFullPaidAmount(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_47, [
            _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label" }, "Расчетный месяц", -1)),
            _createElementVNode("input", {
              type: "number",
              class: "form-control",
              disabled: "",
              value: _ctx.searchParam.accountingMonth
            }, null, 8, _hoisted_48)
          ]),
          _createElementVNode("div", _hoisted_49, [
            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "form-label" }, "Расчетный год", -1)),
            _createElementVNode("input", {
              type: "number",
              class: "form-control",
              disabled: "",
              value: _ctx.searchParam.accountingYear
            }, null, 8, _hoisted_50)
          ]),
          (_ctx.searchParam.lmsIdList != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label" }, "Список БИНов ДО", -1)),
                _createElementVNode("textarea", {
                  cols: "15",
                  rows: "5",
                  class: "form-control",
                  disabled: "",
                  value: _ctx.searchParam.binList
                }, null, 8, _hoisted_52)
              ]))
            : _createCommentVNode("", true),
          (_ctx.searchParam.lmsIdList != '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                _cache[41] || (_cache[41] = _createElementVNode("label", { class: "form-label" }, "Список LMS ID", -1)),
                _createElementVNode("textarea", {
                  cols: "15",
                  rows: "5",
                  class: "form-control",
                  disabled: "",
                  value: _ctx.searchParam.lmsIdList
                }, null, 8, _hoisted_54)
              ]))
            : _createCommentVNode("", true),
          (_ctx.kato != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _cache[42] || (_cache[42] = _createElementVNode("label", { class: "form-label" }, "Населенный пункт", -1)),
                _createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  disabled: "",
                  value: _ctx.formattedKatoLabel(_ctx.kato)
                }, null, 8, _hoisted_56)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_57, [
            _cache[43] || (_cache[43] = _createElementVNode("label", {
              for: "paidDate",
              class: "form-label"
            }, "Дата выплаты", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "form-control",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.fullPaidAmountForm.paidDate) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.fullPaidAmountForm.paidDate]
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-success",
              disabled: _ctx.fullPaidAmountForm.isLoading
            }, _toDisplayString(_ctx.fullPaidAmountForm.isLoading ? "Загрузка" : "Сохранить"), 9, _hoisted_59),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-warning",
              disabled: _ctx.fullPaidAmountForm.isLoading,
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeFullPaidModel && _ctx.closeFullPaidModel(...args)))
            }, "Закрыть", 8, _hoisted_60)
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.showUploadModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _cache[45] || (_cache[45] = _createElementVNode("h4", null, "Выберите .xlsx файл для загрузки Номера платежей", -1)),
            _createElementVNode("form", {
              onSubmit: _cache[17] || (_cache[17] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleUploadSubmit && _ctx.handleUploadSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_63, [
                _cache[44] || (_cache[44] = _createElementVNode("label", {
                  for: "timesheetFile",
                  class: "form-label"
                }, " Выберите .xlsx файл ", -1)),
                _createElementVNode("input", {
                  type: "file",
                  id: "timesheetFile",
                  class: "form-control",
                  required: "",
                  accept: ".xlsx",
                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "submit-btn",
                  disable: _ctx.isLoading
                }, _toDisplayString(_ctx.isLoading ? 'Загружается...' : 'Загрузить'), 9, _hoisted_65)
              ])
            ], 32),
            _createElementVNode("button", {
              class: "close-modal-btn",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showUploadModal = false))
            }, "Закрыть")
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}